import type { Reducer } from 'redux';
import { SAVE_STATE_VALIDATION_RESULT } from '../actionTypes/saveValidationActionTypes';

export type SaveValidationState = {
    isOnSaveFlow: boolean;
    isValid: boolean;
    errors: Record<string, string[]>;
};

export type SaveValidationReducer = Reducer<SaveValidationState>;

export const INITIAL_SAVE_VALIDATION_STATE: SaveValidationState = {
    isOnSaveFlow: false,
    isValid: true,
    errors: {}
};

export const reducer = (state: SaveValidationState = INITIAL_SAVE_VALIDATION_STATE, action: any) => {
    switch (action.type) {
        case SAVE_STATE_VALIDATION_RESULT: {
            if (!action.payload.isValid) {
                return {
                    ...state,
                    ...action.payload,
                    isOnSaveFlow: true
                };
            } else {
                // If is valid, exit save flow and clear errors
                return {
                    ...state,
                    isValid: true,
                    errors: {},
                    isOnSaveFlow: false
                };
            }
        }
    }
    return state;
};
